import moment from 'moment';
import Discount5off20Image from 'assets/recommendedDiscounts/discounts-5off20-image.svg';
import DiscountFixedPercentOffNewItemsImage from 'assets/recommendedDiscounts/discounts-fixed-precent-off-new-items-image.svg';
import DiscountBogoImage from 'assets/recommendedDiscounts/discounts-bogo-image.svg';
import Discount15off35Image from 'assets/recommendedDiscounts/discounts-15off35-image.svg';
import DiscountWeekendImage from 'assets/recommendedDiscounts/discounts-weekend-image.svg';
import Discount2offNewItemsImage from 'assets/recommendedDiscounts/discounts-2-off-new-items-image.svg';
import Discount10off25Image from 'assets/recommendedDiscounts/discounts-10off25-image.svg';
import DiscountVipImage from 'assets/recommendedDiscounts/discounts-vip-image.svg';
import Discount6off25Image from 'assets/recommendedDiscounts/discounts-6off25-image.svg';
import DiscountMondayImage from 'assets/recommendedDiscounts/discounts-monday-image.svg';
import DiscountStepUpImage from 'assets/recommendedDiscounts/discounts-step-up-image.svg';
import DiscountBogoOnSidesImage from 'assets/recommendedDiscounts/discounts-bogo-on-sides-image.svg';
import Discount12off40Image from 'assets/recommendedDiscounts/discounts-12off40-image.svg';
import DiscountFamilyImage from 'assets/recommendedDiscounts/discounts-family-image.svg';
import DiscountDrinksImage from 'assets/recommendedDiscounts/discounts-drinks-image.svg';
import DiscountWelcomeImage from 'assets/recommendedDiscounts/discounts-welcome-image.svg';
import DiscountNewbieGiftImage from 'assets/recommendedDiscounts/discounts-newbie-gift-image.svg';
import DiscountHolidayImage from 'assets/recommendedDiscounts/discounts-holiday-image.svg';
import DiscountLunchImage from 'assets/recommendedDiscounts/discounts-lunch-image.svg';
import DiscountHappyHourImage from 'assets/recommendedDiscounts/discounts-happy-hour-image.svg';
import DiscountSnack5Image from 'assets/recommendedDiscounts/discounts-snack5-image.svg';
import DiscountWeatherImage from 'assets/recommendedDiscounts/discounts-weather-image.svg';
import DiscountFamily15Image from 'assets/recommendedDiscounts/discounts-family15-image.svg';
import DiscountGoBigImage from 'assets/recommendedDiscounts/discounts-go-big-image.svg';

const year = moment().year();
const nextYear = moment().add(1, 'year').year();

export const DISCOUNT_V2 = {
  ID: 'id',
  STATUS: 'status',
  TYPE: 'rate.type',
  DISCOUNT_VALUE: 'rate.value',
  NAME: 'name',
  MIN_ORDER: 'subtotal.min',
  START_DATE: 'availability.activatesAtLocal',
  END_DATE: 'availability.deactivatesAtLocal',
  EMAIL_MARKETING: 'EmailMarketing'
};

export const DISCOUNT_MODALS_V2 = {
  SELECT: 'selectDiscount',
  TURN_ON: 'turnOnDiscount',
  DELETE: 'deleteDiscount',
  DISABLE: 'disableDiscount'
};

export const RECOMMENDED_DISCOUNT_CATEGORIES = [
  {
    key: 'newCustomer',
    name: 'New Customer',
    subtitle: 'Bring in first-time customers'
  },
  {
    key: 'itemLevel',
    name: 'Item-Level & BOGO',
    subtitle: 'Discount specific items or pair items together'
  },
  {
    key: 'timeAndDay',
    name: 'Time & Day-Based',
    subtitle: 'Drive traffic during slow hours or specific days'
  },
  {
    key: 'orderTotal',
    name: 'Order Total Discounts',
    subtitle: 'Encourage larger baskets with threshold discounts'
  },
  {
    key: 'promoCode',
    name: 'Promo Code Campaigns',
    subtitle: 'Shareable codes for email, SMS, and ads'
  }
];

export const DISCOUNT_TYPE = {
  PERCENTAGE: 'Percentage', // 1
  FIXED: 'Fixed', // 0
  BOGO: 'Bogo',
  SPECIFIC_ITEMS: 'SpecificItems',
  WHOLE_CART: 'WholeCart'
};

export const DISCOUNT_STATUS = {
  ACTIVE: 'Active', // 1
  ARCHIVED: 'Archived' // 0
};

export const DISCOUNT_STATUS_FILTER = {
  ACTIVE: 'Active',
  ARCHIVED: 'Archived',
  ALL: 'All'
};

export const DISCOUNT_STATUS_FILTER_LABEL = {
  [DISCOUNT_STATUS_FILTER.ACTIVE]: 'Active',
  [DISCOUNT_STATUS_FILTER.ARCHIVED]: 'Archived',
  [DISCOUNT_STATUS_FILTER.ALL]: 'All Discounts'
};

export const DISCOUNT_POSTHOG_EVENTS = {
  MODAL_OPENED: 'discount_modal_opened',
  SAVE: 'discount_save_attempted'
};

export const FIELDS_TO_REMOVE = [
  'id',
  'createdAt',
  'updatedAt',
  'version',
  'status'
];

export const RECOMMENDED_DISCOUNT_IDS = {
  FIVE_OFF_TWENTY: '5-off-20',
  FIXED_PERCENT_OFF_NEW_ITEMS: 'fixed-percent-off-new-items',
  BOGO: 'bogo',
  FIFTEEN_OFF_THIRTY_FIVE: '15-off-35',
  WEEKEND_SPECIAL: 'weekend-special',
  TWO_OFF_NEW_ITEMS: '2-off-new-items',
  TEN_OFF_TWENTY_FIVE: '10-off-25',
  VIP_OFFER: 'vip-offer',
  SIX_OFF_TWENTY_FIVE: '6-off-25',
  MONDAY_KICKOFF: 'monday-kickoff',
  STEP_UP: 'step-up',
  BOGO_ON_SIDES: 'bogo-on-sides',
  TWELVE_OFF_FORTY: '12-off-40',
  FAMILY_MEAL_BOOST: 'family-meal-boost',
  DISCOUNT_ON_DRINKS: 'discount-on-drinks',
  WELCOME_15: 'welcome-15',
  WELCOME_5: 'welcome-5',
  HOLIDAY_SPECIAL: 'holiday-special',
  LUNCH_SPECIAL: 'lunch-special',
  HAPPY_HOUR: 'happy-hour',
  SNACK5: 'snack5',
  WEATHER_PROMO: 'weather-promo',
  FAMILY15: 'family15',
  GO_BIG: 'go-big'
};

export const RECOMMENDED_DISCOUNTS = [
  {
    id: RECOMMENDED_DISCOUNT_IDS.WELCOME_15,
    title: 'Welcome — 15% off $45',
    label: 'popular',
    description: 'Make a great first impression.',
    advice: false,
    visual: '15% off $45+ order with code WELCOME15',
    img: DiscountWelcomeImage,
    category: 'newCustomer'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.WEEKEND_SPECIAL,
    title: 'Weekend Special',
    label: 'new',
    description: 'Get more orders on Fridays & Saturdays.',
    advice: false,
    visual: '15% off weekend orders of $20 or more',
    img: DiscountWeekendImage,
    category: 'timeAndDay'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.BOGO,
    title: 'BOGO',
    label: 'popular',
    description: 'Simple & popular',
    advice: false,
    visual: 'Buy one fries, get one free',
    img: DiscountBogoImage,
    category: 'itemLevel'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.LUNCH_SPECIAL,
    title: '2-4 PM Mid-Day Deal',
    label: 'new',
    description: 'Fill slow hours.',
    advice: false,
    visual: '$5 off orders placed between 2-4pm',
    img: DiscountLunchImage,
    category: 'timeAndDay'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.FIXED_PERCENT_OFF_NEW_ITEMS,
    title: 'Fixed % Off New Items',
    label: false,
    description: 'Promote your latest additions.',
    advice: false,
    visual: '20% off new menu items',
    img: DiscountFixedPercentOffNewItemsImage,
    category: 'itemLevel'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.WEATHER_PROMO,
    title: 'Weather Promo',
    label: false,
    description: 'Match the mood with the forecast.',
    advice: false,
    visual: '$3 off hot drinks on cold days',
    img: DiscountWeatherImage,
    category: 'timeAndDay'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.HAPPY_HOUR,
    title: 'Happy Hour Deal',
    label: false,
    description: 'Drive post-work orders',
    advice: false,
    visual: 'BOGO appetizers from 5-6pm',
    img: DiscountHappyHourImage,
    category: 'timeAndDay'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.VIP_OFFER,
    title: 'VIP Offer',
    label: false,
    description: 'Reward customers with VIP offer.',
    advice: false,
    visual: '$5 off any order over $20 with code VIP',
    img: DiscountVipImage,
    category: 'promoCode'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.HOLIDAY_SPECIAL,
    title: 'Holiday Special',
    label: 'popular',
    description: 'Celebrate the season with savings.',
    advice: false,
    visual: '$10 off $40+ for seasonal occasions',
    img: DiscountHolidayImage,
    category: 'timeAndDay'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.MONDAY_KICKOFF,
    title: 'Monday Kickoff',
    label: false,
    description: 'Boosts slow start-of-week orders',
    advice: false,
    visual: '$5 off $25+ on Mondays',
    img: DiscountMondayImage,
    category: 'timeAndDay'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.STEP_UP,
    title: 'Step-Up Discount',
    label: false,
    description: 'Encourages larger baskets',
    advice: false,
    visual: '$10 off $50+',
    img: DiscountStepUpImage,
    category: 'orderTotal'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.BOGO_ON_SIDES,
    title: 'BOGO on Sides',
    label: false,
    description: 'Great add-on offer',
    advice: false,
    visual: 'BOGO on all sides',
    img: DiscountBogoOnSidesImage,
    category: 'itemLevel'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.TWELVE_OFF_FORTY,
    title: '$12 Off $40+',
    label: false,
    description: 'Great for bundle upsells.',
    advice: 'AOV increase of 30%+ with min spend',
    visual: '$12 off $40 order',
    img: Discount12off40Image,
    category: 'orderTotal'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.FAMILY_MEAL_BOOST,
    title: 'Family Meal Boost',
    label: false,
    description: 'Promote larger meals',
    advice: false,
    visual: '15% off orders of $40+ and up',
    img: DiscountFamilyImage,
    category: 'orderTotal'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.DISCOUNT_ON_DRINKS,
    title: 'Discount on Drinks',
    label: false,
    description: 'Increase average tab',
    advice: false,
    visual: '20% off all drinks',
    img: DiscountDrinksImage,
    category: 'itemLevel'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.FIFTEEN_OFF_THIRTY_FIVE,
    title: '$15 Off $35+',
    label: false,
    description: 'Encourages larger baskets.',
    advice: 'A $35-$50 minimum spend performs best',
    visual: '$15 off $30 order',
    img: Discount15off35Image,
    category: 'orderTotal'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.WELCOME_5,
    title: 'Welcome — $5 off $30',
    label: false,
    description: 'A little something extra',
    advice: false,
    visual: '$5 off $30+ order with code WELCOME5',
    img: DiscountNewbieGiftImage,
    category: 'newCustomer'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.FIVE_OFF_TWENTY,
    title: '$5 Off $25+',
    label: false,
    description: 'Simple, effective and easy to understand',
    advice: 'Increases AOV by 25%',
    visual: '$5 off $25 order',
    img: Discount5off20Image,
    category: 'orderTotal'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.TWO_OFF_NEW_ITEMS,
    title: '$2 Off New Items',
    label: false,
    description: 'Promote high-margin items',
    advice: false,
    visual: 'e.g., $2 off any large pizza',
    img: Discount2offNewItemsImage,
    category: 'itemLevel'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.TEN_OFF_TWENTY_FIVE,
    title: '$10 Off $25+',
    label: false,
    description: 'Drives high open & conversion rates.',
    advice: false,
    visual: '$5 off $20 order',
    img: Discount10off25Image,
    category: 'orderTotal'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.SNACK5,
    title: 'Insider Offer: SNACK5',
    label: false,
    description: 'Quick and easy savings.',
    advice: false,
    visual: '$5 off $20+ with code SNACK5',
    img: DiscountSnack5Image,
    category: 'promoCode'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.SIX_OFF_TWENTY_FIVE,
    title: '$6 Off $25+',
    label: false,
    description: 'Versatile and scalable',
    advice: false,
    visual: '$6 off any order over $25',
    img: Discount6off25Image,
    category: 'orderTotal'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.FAMILY15,
    title: 'Unlock Deal: FAMILY15',
    label: false,
    description: 'Perfect for larger group meals.',
    advice: false,
    visual: '15% off orders $40+ with code FAMILY15',
    img: DiscountFamily15Image,
    category: 'promoCode'
  },
  {
    id: RECOMMENDED_DISCOUNT_IDS.GO_BIG,
    title: 'Go Big, Save Big',
    label: false,
    description: 'Stronger incentive for larger baskets.',
    advice: false,
    visual: '$20 off $75+ with code BIGSAVE',
    img: DiscountGoBigImage,
    category: 'promoCode'
  }
];

export const RECOMMENDED_DISCOUNT_CONFIG = {
  [RECOMMENDED_DISCOUNT_IDS.FIVE_OFF_TWENTY]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '$5 Off $20+',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 5
    },
    subtotal: {
      min: 20
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.FIXED_PERCENT_OFF_NEW_ITEMS]: {
    type: DISCOUNT_TYPE.SPECIFIC_ITEMS,
    name: '20% off new items',
    rate: {
      type: DISCOUNT_TYPE.PERCENTAGE,
      value: 20
    },
    subtotal: {
      min: 0
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.BOGO]: {
    type: DISCOUNT_TYPE.BOGO,
    name: 'Buy one, get one',
    rate: {
      type: DISCOUNT_TYPE.PERCENTAGE,
      value: 100
    },
    subtotal: {
      min: 0
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.FIFTEEN_OFF_THIRTY_FIVE]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '$15 Off $35+',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 15
    },
    subtotal: {
      min: 35
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.WEEKEND_SPECIAL]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '15% off on weekends',
    rate: {
      type: DISCOUNT_TYPE.PERCENTAGE,
      value: 15
    },
    subtotal: {
      min: 20
    },
    availability: {
      weekly: [
        {
          days: ['Fri', 'Sat', 'Sun'],
          time: [{start: {hour: 0, minute: 0}, end: {hour: 23, minute: 59}}]
        }
      ]
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.TWO_OFF_NEW_ITEMS]: {
    type: DISCOUNT_TYPE.SPECIFIC_ITEMS,
    name: '$2 off new items',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 2
    },
    subtotal: {
      min: 0
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.TEN_OFF_TWENTY_FIVE]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '$10 Off $25+',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 10
    },
    subtotal: {
      min: 25
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.VIP_OFFER]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: 'VIP Offer',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 5
    },
    subtotal: {
      min: 20
    },
    promoCode: {
      code: 'VIP'
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.SIX_OFF_TWENTY_FIVE]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '$6 Off $25+',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 6
    },
    subtotal: {
      min: 25
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.MONDAY_KICKOFF]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '$5 Off $25+',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 5
    },
    subtotal: {
      min: 25
    },
    availability: {
      weekly: [
        {
          days: ['Mon'],
          time: [{start: {hour: 0, minute: 0}, end: {hour: 23, minute: 59}}]
        }
      ]
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.STEP_UP]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '$10 Off $50+',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 10
    },
    subtotal: {
      min: 50
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.BOGO_ON_SIDES]: {
    type: DISCOUNT_TYPE.BOGO,
    name: 'Add-on offer',
    rate: {
      type: DISCOUNT_TYPE.PERCENTAGE,
      value: 100
    },
    subtotal: {
      min: 0
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.TWELVE_OFF_FORTY]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '$12 Off $40+',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 12
    },
    subtotal: {
      min: 40
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.FAMILY_MEAL_BOOST]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '15% Off orders $40+',
    rate: {
      type: DISCOUNT_TYPE.PERCENTAGE,
      value: 15
    },
    subtotal: {
      min: 40
    },
    isPromotional: false,
    promoCode: {
      code: 'BACK15N',
      usageLimit: {
        type: 'PerCustomer',
        maxUsages: 1
      }
    },
    marketing: {
      email: {
        isEnabled: true
      }
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.DISCOUNT_ON_DRINKS]: {
    type: DISCOUNT_TYPE.SPECIFIC_ITEMS,
    name: '20% off all drinks',
    rate: {
      type: DISCOUNT_TYPE.PERCENTAGE,
      value: 20
    },
    subtotal: {
      min: 0
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.WELCOME_15]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: 'Welcome — 15% off $45',
    rate: {
      type: DISCOUNT_TYPE.PERCENTAGE,
      value: 15
    },
    subtotal: {
      min: 45
    },
    promoCode: {
      code: 'WELCOME15',
      usageLimit: {
        type: 'PerCustomer',
        maxUsages: 1
      }
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.WELCOME_5]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: 'Welcome — $5 off $30',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 5
    },
    subtotal: {
      min: 30
    },
    promoCode: {
      code: 'WELCOME5',
      usageLimit: {
        type: 'PerCustomer',
        maxUsages: 1
      }
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.HOLIDAY_SPECIAL]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '$10 off $40 holiday special',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 10
    },
    subtotal: {
      min: 40
    },
    availability: {
      activatesAtLocal: moment.utc(`${year}-12-01 00:00:00`).format(),
      deactivatesAtLocal: moment.utc(`${nextYear}-02-28 23:59:59`).format()
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.LUNCH_SPECIAL]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '$5 off lunch special',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 5
    },
    subtotal: {
      min: 25
    },
    availability: {
      weekly: [
        {
          days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          time: [{start: {hour: 14, minute: 0}, end: {hour: 16, minute: 0}}]
        }
      ]
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.HAPPY_HOUR]: {
    type: DISCOUNT_TYPE.BOGO,
    name: 'BOGO happy hour',
    rate: {
      type: DISCOUNT_TYPE.PERCENTAGE,
      value: 100
    },
    subtotal: {
      min: 0
    },
    availability: {
      weekly: [
        {
          days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          time: [{start: {hour: 17, minute: 0}, end: {hour: 18, minute: 0}}]
        }
      ]
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.WEATHER_PROMO]: {
    type: DISCOUNT_TYPE.SPECIFIC_ITEMS,
    name: '$3 off hot drinks',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 3
    },
    subtotal: {
      min: 0
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.FAMILY15]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '15% off orders $40 FAMILY',
    rate: {
      type: DISCOUNT_TYPE.PERCENTAGE,
      value: 15
    },
    subtotal: {
      min: 40
    },
    promoCode: {
      code: 'FAMILY15'
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.SNACK5]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: '$5 off $20 SNACK5',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 5
    },
    subtotal: {
      min: 20
    },
    promoCode: {
      code: 'SNACK5'
    }
  },
  [RECOMMENDED_DISCOUNT_IDS.GO_BIG]: {
    type: DISCOUNT_TYPE.WHOLE_CART,
    name: 'BIG SAVE',
    rate: {
      type: DISCOUNT_TYPE.FIXED,
      value: 20
    },
    subtotal: {
      min: 75
    },
    promoCode: {
      code: 'BIGSAVE'
    }
  }
};
